<script>
export default {
  methods: {
    sidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-hidden')
      document.body.classList.toggle('brand-minimized')
    },
    sidebarMinimize (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-minimized')
      document.body.classList.toggle('brand-minimized')
    },
    mobileSidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-mobile-show')
    },
    asideToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('aside-menu-hidden')
    }
  }
}
</script>
<template>
  <header class="app-header navbar">
    <span class="float-left">
      <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">&#9776;</button>
      <b-link class="navbar-brand" to="/home"></b-link>
      <button class="navbar-toggler sidebar-toggler d-md-down-none" type="button" @click="sidebarMinimize">&#9776;</button>
    </span>
    <slot />
    <div class="tarjaSeocredito"></div>
  </header>
</template>

<style scoped>
  .app-header.navbar .navbar-toggler {
    margin-right: 0px!important;
  }
  .app-header.navbar .navbar-brand {
    background-color:  #4B4B4D;
    /* background-color:  #499dc7; */
  }
  .app-header.navbar span * {
    float: left;
  }
  .app-header.navbar span button{
    height: 49px;
    line-height: 36px;
  }
</style>



// WEBPACK FOOTER //
// header.vue?0e49b83e